import { CheckCircle2 } from "lucide-react";

export default function ConfirmationEmailPage() {
  return (
    <div className="min-h-screen bg-[#0B1F3B] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="mb-8">
          <span className="font-heading text-3xl font-bold">
            <span className="text-white">FINOVÉO</span>
            <span className="text-[#59C3A6]"> Conseil</span>
          </span>
        </div>

        {/* Success Icon */}
        <div className="w-20 h-20 rounded-full bg-[#59C3A6]/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 size={40} className="text-[#59C3A6]" />
        </div>

        {/* Message */}
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          Votre compte a été confirmé avec succès !
        </h1>
        <p className="text-slate-400 text-base leading-relaxed">
          Vous pouvez fermer cette fenêtre et revenir sur votre diagnostic.
        </p>

        {/* Visual hint */}
        <div className="mt-8 p-4 rounded-xl bg-[#112A4F]/30 border border-white/5">
          <p className="text-slate-500 text-sm">
            L'onglet avec votre diagnostic se mettra à jour automatiquement.
          </p>
        </div>
      </div>
    </div>
  );
}
